import { ImageEmbed } from '@bnnvara/embeds';
import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import ComposableContext from '../helpers/composable/ComposableContext';
import getSourceSetValues from '../helpers/getSourceSetValues';
import { resizeImageSourceMax } from '../helpers/resizeImageSource';

const getSrcProps = (src, skipResize) => {
  if (skipResize) {
    return { src };
  }

  return {
    src: resizeImageSourceMax(src, 16 / 9),
    srcSet: getSourceSetValues(src, 16 / 9).join(', '),
  };
};

const ComposableArticleHeaderImage = ({ url, ...props }) => {
  const pageContext = useContext(ComposableContext);
  const category = pageContext?.data?.brand?.article?.categories?.[0]?.slug;

  // Due to an invalid migration on test and acc, we have 2 different "cartoon" rubrieken
  const skipResize = ['cartoon', 'cartoons'].includes(category);

  const imgProps = getSrcProps(url, skipResize);

  return (
    <GridItem
      fullWidthItemSm
      columnStartSm="1"
      columnEndSm="span 12"
      columnStartLg="2"
      columnEndLg="span 10"
    >
      <ImageEmbed {...imgProps} {...props} />
    </GridItem>
  );
};

ComposableArticleHeaderImage.propTypes = {
  url: PropTypes.string.isRequired,
};

export default ComposableArticleHeaderImage;
